<template>
  <v-btn outline
         large
         :color="color"
         v-bind="$attrs"
         v-on="$listeners"
         :loading="loading"
        :class="loading?'lock':''"
        @click="loader = 'loading'">
    <slot></slot>
  </v-btn>
</template>
<script>
import BaseBtn from './BaseBtn'
export default {
  name: 'btn-lg-default',
  extends: BaseBtn,
  props: {
    color: {
      type: String,
      default: 'black'
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-btn.v-btn--outline {
  background: #FFF !important;
}
</style>
